(function () {
  var roots = document.querySelectorAll(
    'main[data-template="page.about-us"], main[data-template="page.jewelry-care-guide"]'
  );
  if (!roots.length) return;

  var ACCENT_CLASS = 'about-us-heading-accent';
  var DARK_CLASS = 'about-us-heading-dark';
  var SKIP_ANCESTOR = '.luxury-perfume-slider, .uvx90-slider, .breadcrumb, .breadcrumb-nav';

  function hasAccentChild(el) {
    return el.querySelector(
      '.' + ACCENT_CLASS + ', .trust-highlights__section-heading-accent, [class*="heading-accent"], [class*="title-accent"]'
    );
  }

  function splitLastWord(el) {
    if (el.dataset.n3voHeadingSplit === 'true') return;
    if (el.closest(SKIP_ANCESTOR)) return;
    if (!el.closest('.shopify-section')) return;
    if (hasAccentChild(el)) return;
    if (el.querySelector('.founder-story__heading-line')) return;

    var text = (el.textContent || '').trim().replace(/\s+/g, ' ');
    if (!text) return;

    var words = text.split(' ');
    var last = words.pop();
    var rest = words.join(' ');

    if (!last) return;

    el.innerHTML = rest
      ? '<span class="' + DARK_CLASS + '">' + rest + '</span><span class="' + ACCENT_CLASS + '">' + last + '</span>'
      : '<span class="' + ACCENT_CLASS + '">' + last + '</span>';
    el.dataset.n3voHeadingSplit = 'true';
  }

  roots.forEach(function (root) {
    root.querySelectorAll('h2, h3').forEach(splitLastWord);
  });
})();
